import React from "react";

// components
import { Select } from "../../../components/select/Select";
import Button from "../../../components/button/Button";
import Spinner from "../../../components/spinner/Spinner";

// hooks
import { useUsersFetch, useUsersForm } from "./use-users";

// styles
import styles from "./UsersScreen.module.scss";

export function UsersScreen() {
  const { isUsersLoading } = useUsersFetch();
  const {
    userFormData,
    usersEmailsOptions,
    profileRoleOptions,
    handleChangeUserData,
    onSubmit,
  } = useUsersForm();

  return (
    <form className={styles.formWrapper}>
      {isUsersLoading ? (
        <Spinner className={styles.loader} />
      ) : (
        <>
          <div className={styles.selectWrapper}>
            <Select
              placeholder="Email"
              options={usersEmailsOptions}
              value={usersEmailsOptions.find(
                ({ value }) => value === userFormData.email_id
              )}
              onChange={(value) => handleChangeUserData(value, "email_id")}
            />
            <Select
              placeholder="Role"
              options={profileRoleOptions}
              value={profileRoleOptions.find(
                ({ value }) => value === userFormData.role
              )}
              onChange={(value) => handleChangeUserData(value, "role")}
            />
          </div>
          <div className={styles.buttonWrapper}>
            <Button onClick={(e) => onSubmit(e)} width="auto">
              Submit
            </Button>
          </div>
        </>
      )}
    </form>
  );
}
